// leight polyfill for Object.assign
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (base) {
  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return Object.keys(extend).reduce(function (out, key) {
    base[key] = extend[key];
    return out;
  }, {});
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/inline-style-prefix-all/lib/utils/assign.js
// module id = 369
// module chunks = 6